<template>
  <GridChartCard
    :title="title"
    :subtitle="subtitle"
    :hasData="hasData"
    ref="chartCard"
    :disableCSV="true"
    :noDataText="noDataText"
    @draw="createChart"
  />
</template>

<script>
import { Chart } from 'chart.js'
import { getChartColors } from './ChartColors'
import { chartTooltipStyle } from '@/utils/ChartHelpers'

const INVALID_LOCATION_ID = -1

export default {
  name: 'BarChartCardLoadsByYardInstruction',

  components: {
    GridChartCard: () => import('./GridChartCard.vue')
  },

  props: {
    data: {
      type: Object,
      default: undefined
    },
    selectedDestName: {
      type: String,
      required: false,
      default: ''
    },
    selectedDestId: {
      type: Number,
      required: true,
      default: INVALID_LOCATION_ID
    },
    isInteractive: {
      type: Boolean,
      default: false
    }
  },

  data: () => ({
    chart: null
  }),

  watch: {
    data: {
      handler (_) {
        this.$nextTick(() => {
          this.$refs.chartCard.draw()
        })
      },
      deep: true
    }
  },

  computed: {
    title () {
      return (this.selectedDestName !== '' && this.$vuetify.breakpoint.lgAndUp)
        ? `${this.$t('readyForScalingLoadsByYardInstruction')} (${this.selectedDestName})`
        : this.$t('readyForScalingLoadsByYardInstruction')
    },

    subtitle () {
      if (this.$vuetify.breakpoint.mdAndDown && this.selectedDestName) {
        return this.selectedDestName
      }
      return undefined
    },

    xValues () {
      return this.data?.xValues ?? []
    },

    yValues () {
      return this.data?.yValues ?? []
    },

    hasData () {
      return this.yValues.reduce((v, p) => v + p, 0) > 0
    },

    noDataText () {
      return this.selectedDestId === INVALID_LOCATION_ID ? this.$t('dataUnavailableMoreThanOneLocation') : undefined
    }
  },

  methods: {
    createChart (canvas) {
      const colors = getChartColors(this.yValues.filter(y => y > 0).length)
      const chart = new Chart(canvas, {
        type: 'bar',
        data: {
          labels: this.xValues,
          datasets: [{
            label: this.$t('loadCount'),
            data: this.yValues,
            backgroundColor: colors
          }]
        },
        options: {
          maintainAspectRatio: false,
          responsive: true,
          plugins: {
            legend: {
              display: false
            },
            tooltip: {
              ...chartTooltipStyle
            }
          },
          scales: {
            y: {
              beginAtZero: true,
              ticks: {
                stepSize: 1
              }
            }
          }
        }
      })
      this.chart = chart
    }
  }
}
</script>
